/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Launch_Vote_CountInputs */

const en_directory_launch_vote_count = /** @type {(inputs: Directory_Launch_Vote_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} votes`)
};

const zh_directory_launch_vote_count = /** @type {(inputs: Directory_Launch_Vote_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 票`)
};

/**
* | output |
* | --- |
* | "{count} votes" |
*
* @param {Directory_Launch_Vote_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_vote_count = /** @type {((inputs: Directory_Launch_Vote_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Vote_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_vote_count(inputs)
	return zh_directory_launch_vote_count(inputs)
});
export { directory_launch_vote_count as "directory.launch.vote_count" }